export default __webpack_public_path__ + "static/media/Strugani 16.0569d22f.jpg";